import React from "react";
import ReactDOM from "react-dom/client";
import { createHashRouter, RouterProvider } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import "./index.css";
import Layout from "./pages/layout/Layout";
import Chat from "./pages/chat/Chat";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute";
import { AuthProvider } from "./authContext";
import { AppInsightsErrorBoundary, reactPlugin } from "./appInsights";

const router = createHashRouter([
    {
        path: "/",
        element: (
            <ProtectedRoute>
                <Layout />
            </ProtectedRoute>
        ),
        children: [
            {
                index: true,
                element: <Chat />
            },
            {
                path: "data",
                lazy: () => import("./pages/data/Data")
            },
            {
                path: "help",
                lazy: () => import("./pages/help/Help")
            },
            {
                path: "*",
                lazy: () => import("./pages/NoPage")
            }
        ]
    }
]);

const queryClient = new QueryClient();

// Simple error fallback component
const ErrorFallback = () => (
    <div className="flex min-h-screen items-center justify-center bg-gray-100">
        <div className="max-w-md rounded-lg bg-white p-6 shadow-lg">
            <div className="text-center">
                <h3 className="mb-2 text-lg font-medium text-red-800">Something went wrong</h3>
                <p className="mb-4 text-sm text-red-700">
                    We&apos;re sorry, but something unexpected happened. The error has been logged and will be reviewed.
                </p>
                <button
                    type="button"
                    className="rounded-md bg-red-50 px-3 py-2 text-sm font-medium text-red-800 hover:bg-red-100"
                    onClick={() => window.location.reload()}
                >
                    Reload page
                </button>
            </div>
        </div>
    </div>
);

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
    <React.StrictMode>
        <AppInsightsErrorBoundary appInsights={reactPlugin} onError={ErrorFallback}>
            <AuthProvider>
                <QueryClientProvider client={queryClient}>
                    <RouterProvider router={router} />
                </QueryClientProvider>
            </AuthProvider>
        </AppInsightsErrorBoundary>
    </React.StrictMode>
);
